export const displayCelestialCoords = (ra, dec) => {
  const ra_options = {minimumIntegerDigits:3,maximumFractionDigits:2,minimumFractionDigits:2};
  const ra_fixed = ra.toLocaleString('en', ra_options);
  const dec_options = {minimumIntegerDigits:2,maximumFractionDigits:2,minimumFractionDigits:2};
  const dec_fixed = dec.toLocaleString('en', dec_options);

  return `${ra_fixed} ${dec_fixed<0 ? '' : '+'}${dec_fixed}`;
};